import BrowseFilesButton, { BrowseFilesEvent } from "./BrowseFilesButton";

export default BrowseFilesButton;
export type { BrowseFilesEvent as FileEvent };
